import React from "react"

import { Building2, Clock, Package, Ticket, Truck, Warehouse } from "lucide-react"

import Icon from "@/components/Icon"
import { TabsList, TabsTrigger } from "@/components/ui/tabs"

import RoleTeamGuard from "../../guards/RoleTeamGuard"

interface SheriffTabsListProps {
  activeTab: string
  onValueChange: (value: string) => void
}

const SheriffTabsList: React.FC<SheriffTabsListProps> = () => {
  return (
    <TabsList className="mb-4">
      {/* Delivery: Admin, DSP, Manager */}
      <RoleTeamGuard roles={["Admin", "DSP", "Manager"]} fallback={null}>
        <TabsTrigger value="delivery" className="flex items-center gap-2">
          <Truck size={16} />
          Delivery Schedule
        </TabsTrigger>
      </RoleTeamGuard>

      {/* Collection: Admin, Manager only */}
      <RoleTeamGuard roles={["Admin", "Manager"]} fallback={null}>
        <TabsTrigger value="collection" className="flex items-center gap-2">
          <Package size={16} />
          Collection Schedule
        </TabsTrigger>
      </RoleTeamGuard>

      {/* Sortation: Admin, Manager only */}
      <RoleTeamGuard roles={["Admin", "Manager"]} fallback={null}>
        <TabsTrigger value="sortation" className="flex items-center gap-2">
          <Warehouse size={16} />
          Sortation Schedule
        </TabsTrigger>
      </RoleTeamGuard>

      {/* Internal: Admin, Manager only */}
      <RoleTeamGuard roles={["Admin", "Manager"]} fallback={null}>
        <TabsTrigger value="internal" className="flex items-center gap-2">
          <Building2 size={16} />
          Internal Schedule
        </TabsTrigger>
      </RoleTeamGuard>

      {/* Timesheets: Admin, Manager only */}
      <RoleTeamGuard roles={["Admin", "Manager"]} fallback={null}>
        <TabsTrigger value="timesheets" className="flex items-center gap-2">
          <Clock size={16} />
          Timesheets
        </TabsTrigger>
      </RoleTeamGuard>

      {/* Tickets: Admin, DSP, Manager */}
      <RoleTeamGuard roles={["Admin", "DSP", "Manager"]} fallback={null}>
        <TabsTrigger value="tickets" className="flex items-center gap-2">
          <Ticket size={16} />
          Tickets
        </TabsTrigger>
      </RoleTeamGuard>

      <RoleTeamGuard
        teams={["Admin", "Central Operations", "Driver Operations", "Depot"]}
        fallback={null}
      >
        <TabsTrigger value="re-waving" className="flex items-center gap-2">
          <Icon name="arrowUDownRight" className="h-4 w-4" />
          Re-waving
        </TabsTrigger>
      </RoleTeamGuard>

      <RoleTeamGuard permissions={["view.page.incentives"]} fallback={null}>
        <TabsTrigger value="incentives" className="flex items-center gap-2">
          <Icon name="currencyGbp" className="h-4 w-4" />
          Incentives
        </TabsTrigger>
      </RoleTeamGuard>
    </TabsList>
  )
}

export default SheriffTabsList
